export const DATE_FORMAT = 'DD MMM YYYY';
export const TIME_FORMAT = 'hh:mm a';
export const UPLOAD_PHOTO = 'uploadphoto-public';
export const appConfigVersion = '1.0.0';